import { useState } from 'react'
import { InventoryLocation } from 'inventory-web'
import { heapEvent } from '@equipmentshare/heaper'

import {
	EuiButton,
	EuiButtonEmpty,
	EuiModalBody,
	EuiModalFooter,
} from '@equipmentshare/ds2'

import InventoryLocationForm, { InventoryLocationFormState } from '../../InventoryLocationForm'
import useUpdateInventoryLocationHandler from '../../../effects/updateInventoryLocation'
import validateForm from '../../InventoryLocationForm/helpers/validateForm'
import useValidateBranchAndName from '../../InventoryLocationForm/helpers/validateBranchAndName'

export type EditInventoryLocationModalProps = {
	onCancel: () => void,
	onSuccess: () => void,
	inventoryLocation: InventoryLocation,
	updateAfterEdit: ( updatedInventoryLocation: InventoryLocation ) => void,
}

export default function EditInventoryLocationModal( { onCancel, onSuccess, inventoryLocation, updateAfterEdit }: EditInventoryLocationModalProps ) {
	const [ formState, setFormState ] = useState<InventoryLocationFormState>( {
		branch: inventoryLocation.branch,
		name: inventoryLocation.name,
		validation: {
			branch: { isInvalid: false },
			name: { isInvalid: false },
		},
	} )
	const [ isSaving, setIsSaving ] = useState( false )
	const validateBranchAndName = useValidateBranchAndName( inventoryLocation )
	const updateStore = useUpdateInventoryLocationHandler( updateAfterEdit )

	const handleCancel = () => {
		heapEvent( 'Inventory - Edit Store Modal - Click - Cancel', {} )
		onCancel()
	}

	const handleSubmit = async() => {
		heapEvent( 'Inventory - Edit Store Modal - Click - Submit', {} )
		setIsSaving( true )

		const { isInvalid, newFormState } = await validateForm( formState, validateBranchAndName, true )
		if ( isInvalid ) {
			setFormState( newFormState )
			setIsSaving( false )
		} else {
			try {
				await updateStore(
					parseInt( inventoryLocation.id, 10 ),
					inventoryLocation.branch.id === formState.branch?.id ? undefined : formState.branch?.id,
					inventoryLocation.name === formState.name ? undefined : formState.name,
				)
			} catch ( e: unknown ) {
				setIsSaving( false )
			}
			onSuccess()
		}
	}

	return (
		<>
			<EuiModalBody>
				<InventoryLocationForm
					formState={formState}
					setFormState={setFormState}
				/>
			</EuiModalBody>
			<EuiModalFooter>
				<EuiButtonEmpty
					color="text"
					id="cancelBtn"
					onClick={handleCancel}
				>
					Cancel
				</EuiButtonEmpty>
				<EuiButton
					id="submitBtn"
					fill
					isLoading={isSaving}
					onClick={handleSubmit}
				>
					Submit
				</EuiButton>
			</EuiModalFooter>
		</>
	)
}
